import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

const rankMedal = ['bg-accent-500 text-background-950', 'bg-background-300 text-foreground-900', 'bg-primary-300 text-background-950'];

export default function Trending() {
  const trending = manhwaList.filter((m) => m.trending).sort((a, b) => b.score - a.score);

  return (
    <section id="trending" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill" /> 人气榜单
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">高分人气榜</h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
              根据评分与热度综合整理的人气韩漫，人气与口碑双在线，追更不迷路的首选榜单。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {trending.map((item, idx) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-center gap-4 rounded-2xl bg-background-50 p-4 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <div
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl font-heading text-xl font-black ${
                  rankMedal[idx] ?? 'bg-background-200 text-foreground-600'
                }`}
              >
                {idx + 1}
              </div>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-lg bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  title={`${item.title} 韩漫人气榜`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="flex items-center gap-0.5 whitespace-nowrap text-sm font-bold text-primary-600">
                    <i className="ri-star-fill" /> {item.score.toFixed(1)}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{item.author} · {item.status} · {item.chapters}话</p>
                <div className="mt-1.5 flex flex-wrap gap-1.5">
                  {item.tags.slice(0, 3).map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <i className="ri-arrow-right-s-line hidden text-foreground-300 sm:block" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}